import React from "react";
import { useHistory } from "react-router-dom";

import { getAutomationDataAttr } from "@/utils/automationUtils";

import ClipboardIcon from "./icon--clipboard.svg?component";
import { ReminderBanner } from "./ReminderBanner";

export function ACPReminder() {
  const history = useHistory();
  const onPress = () => history.push("/app/consents");

  return (
    <ReminderBanner
      cta="Review Consent"
      Icon={<ClipboardIcon />}
      onPress={onPress}
      {...getAutomationDataAttr("patient-home-acp-reminder")}
    >
      Your insurance covers additional care services. Agree to let your care team include them in
      your plan
    </ReminderBanner>
  );
}
